export default __webpack_public_path__ + "img/9cf3d8165f9be0a585a42a523d9b602c.svg";